import { Markdown } from '@cibo/ui'
import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useRollupQuestion } from '../Rollups/RollupQuestionContext'

export const FertilizerReductionRollup = () => {
  const { t } = useTranslation('@cibo/landmanager/DetailEditing/FertilizerReduction')
  const { rollupRequested, setRollupRequested, commitChanges } = useRollupQuestion()

  const handleChange = (value: string) => {
    setRollupRequested(value === 'yes')
    if (value === 'yes') {
      return commitChanges()
    }
  }

  const answer = rollupRequested === undefined ? '' : rollupRequested ? 'yes' : 'no'

  return (
    <Stack>
      <Typography>
        <Markdown>{t('rollupQuestion')}</Markdown>
      </Typography>

      <RadioGroup value={answer} onChange={event => handleChange(event.target.value)}>
        <FormControlLabel
          value={'yes'}
          control={<Radio />}
          label={`${t('rollupQuestionYes')}`}
          data-testid="rollup-yes"
        />
        <FormControlLabel
          value={'no'}
          control={<Radio />}
          label={`${t('rollupQuestionNo')}`}
          data-testid="rollup-no"
        />
      </RadioGroup>
    </Stack>
  )
}
